import React, { useState } from 'react';

const SocialSecurity = ({ updateFormData, nextStep, prevStep, onExit }) => {
  const [showWaiverMessage, setShowWaiverMessage] = useState(false);

  const handleAnswer = (answer) => {
    if (answer === false) {
      // Show waiver message
      setShowWaiverMessage(true);
    } else {
      nextStep({ hasSSN: true });
    }
  };

  if (showWaiverMessage) {
    return (
      <div className="question-screen">
        <h1 className="question-title">SOCIAL SECURITY NUMBER REQUIREMENT</h1>

        <div className="question-content">
          <div className="waiver-notice">
            <p>
              When you arrive, the deputy clerk will direct you to a Judge or Justice of the Peace to obtain a waiver.
              The Clerk of Court's fee for this service is $4.00. The Judge or Justice of the Peace granting the waiver
              may charge an additional fee and may require information supporting the need for the waiver.
            </p>
          </div>
        </div>

        <div className="question-actions">
          <button onClick={() => setShowWaiverMessage(false)} className="btn btn-secondary">
            Go Back to Previous Question
          </button>
          <button onClick={() => nextStep({ hasSSN: false })} className="btn btn-primary">
            Continue Application
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="question-screen">
      <button onClick={prevStep} className="btn btn-secondary question-back-button">
        Back to Previous Question
      </button>

      <h1 className="question-title">SOCIAL SECURITY NUMBERS</h1>
      <p className="question-subtitle">Reference: <a href="https://legis.la.gov/legis/Law.aspx?d=106999" target="_blank" rel="noopener noreferrer">La. R.S. 9:224/La. Civil Code Article 74.3.1</a></p>
      <div className="question-content">
        <p>
          Both applicants' Social Security numbers must be provided. Applicants who do not have a Social Security number must
          provide a driver's license; a government issued identification card; a passport; a visa issued by the United States
          Department of State; or a Certificate of Naturalization issued by the United States Citizenship and Immigration Services.
        </p>

        <p>
          If either or both applicants cannot comply with the requirement above, a waiver signed by a Judge or Justice of the
          Peace is needed. The Clerk of Court will provide direction at the time the license is to be issued.
        </p>

        <p className="question-prompt">
          Do you have Social Security numbers?
        </p>
      </div>

      <div className="question-buttons">
        <button onClick={() => handleAnswer(true)} className="question-btn yes">Yes</button>
        <button onClick={() => handleAnswer(false)} className="question-btn no">No</button>
      </div>
    </div>
  );
};

export default SocialSecurity;
